import { Css, Palette, SelectField } from "@homebound/beam";
import { useMemo } from "react";
import { VersionableFragment } from "src/components/ReadyPlanVersionHeader.generated";
import { AggregateVersionStatus } from "src/generated/graphqlTypes";
import { useNavigateToRpav } from "src/hooks/useNavigateToRpav";
import { formatDate } from "./FormattedDate";
import { Icon } from "./Icon";

type ReadyPlanVersionInfo = { aggregateVersions: VersionableFragment[] };

type ReadyPlanVersionHeaderProps = { readyPlan: ReadyPlanVersionInfo; versionId: string; aggregateCheckoutId?: string };

export function ReadyPlanVersionHeader({ readyPlan, versionId, aggregateCheckoutId }: ReadyPlanVersionHeaderProps) {
  const navigateToRpav = useNavigateToRpav();

  const versionOptions = useMemo(
    () =>
      readyPlan.aggregateVersions?.map((v) => ({
        id: v.id,
        name: v.status.code === AggregateVersionStatus.Draft ? `Draft of v${v.version}` : `v${v.version}`,
        promotedAt: v.promotedAt,
        promotedBy: v.promotedBy,
        aggregateCheckout: v.id === aggregateCheckoutId,
      })) ?? [],
    [readyPlan.aggregateVersions, aggregateCheckoutId],
  );

  return (
    <div css={Css.wPx(130).px1.$}>
      <SelectField
        label="version"
        value={versionId}
        options={versionOptions}
        onSelect={navigateToRpav}
        getOptionMenuLabel={(v) => (
          <div css={Css.df.fdc.$}>
            <div css={Css.df.gap1.$}>
              {v.name}{" "}
              {(v.promotedAt || v.aggregateCheckout) && (
                <Icon icon="cart" color={v.aggregateCheckout ? Palette.Blue500 : Palette.Gray500} />
              )}
            </div>
            {v.promotedAt && (
              <div css={Css.xs.gray700.$}>
                Promoted on {formatDate(v.promotedAt, "short")}
                {v.promotedBy && ` by ${v.promotedBy.name}`}
              </div>
            )}
          </div>
        )}
        fieldDecoration={(v) =>
          (v.promotedAt || v.aggregateCheckout) && (
            <Icon icon="cart" color={v.aggregateCheckout ? Palette.Blue500 : Palette.Gray500} />
          )
        }
        autoSort={false}
        labelStyle="hidden"
        borderless
      />
    </div>
  );
}
